module.exports = __webpack_public_path__ + "img/tarj2-1.9955f85c.svg";